import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Badge, Button, Card, Col, Form, Row, Table } from "react-bootstrap";

import { Spin } from "antd";

import toast from "react-hot-toast";

import { ServiceUrl } from "../../utils/serviceUrl";
import { queryParam, upperCase, useQuery } from "../../utils";
import axios from "axios";
import { Toast } from "antd-mobile";

import PsContext from "../../context";

const ExamFeeStatus = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const context = useContext(PsContext);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const q = useQuery();

  const paramValue = (paramName) => {
    let d = queryParam(q);

    return d[paramName] || "";
  };

  useEffect(() => {
    /*   if (params.status == "1")  */ loadOrder();
  }, [params]);

  const loadOrder = (data) => {
    context.setLoader(true);
    const form = new FormData();
    form.append("order_id", paramValue("order_no"));
    form.append("config_id", paramValue("config_id"));
    axios
      .post(ServiceUrl.STUDENTS.ORDER_STATUS, form)
      .then((res) => {
        if (res.data.status === "1") {
          /* console.log(res["data"].data); */
          setDataList(res["data"].data);
          context.setLoader(false);
        }
      })
      .catch((error) => {
        Toast.show({ content: error.message || "An error occurred" });
      })
      .finally(() => {
        context.setLoader(false);
      });
  };

  return (
    <>
      <div data-aos="fade-up">
        <div className="container">
          <Card>
            <Card.Body>
              <Row>
                <Col md={6} sm={6} xs={6}>
                  <label>Order Id</label>
                </Col>
                <Col md={6} sm={6} xs={6} className="text-end">
                  <label>{upperCase(paramValue("order_no"))}</label>
                </Col>
              </Row>
              <Row className="py-2 border-top mt-2">
                <Col md={6} sm={6} xs={6}>
                  <label>Status</label>
                </Col>
                <Col md={6} sm={6} xs={6} className="text-end">
                  {dataList.length > 0 && (
                    <label>
                      {dataList[0].cca_status === "paid" ||
                      dataList[0].cca_status === "shipped" ? (
                        <Badge bg="success">Success</Badge>
                      ) : (
                        <Badge bg="danger">Error</Badge>
                      )}
                    </label>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="mt-4">
            <Card.Header>Instructions</Card.Header>
            <Card.Body>
              1. The payment has been debited from your account but is not
              reflecting on this page, Don't try to make another payment at this
              time.
              <hr />
              2. The status will be updated within 12 hours or automatically
              refunded to your account.
              <hr />
              3. For further assistance, please contact the institution.
            </Card.Body>
          </Card>
          <Row className="mt-4">
            <Col md={12} className="text-center">
              <Link to="/stu/app" className="btn btn-primary">
                <i class="fa-solid fa-house me-2 pe-2 border-end"></i> Go to
                dashboard
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default ExamFeeStatus;
